"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _styles = require("./styles");

var _browser = _interopRequireDefault(require("../../../helpers/browser"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *
 * ScrollArea Component
 *
 * Provides a scrollable area using either react-prefect-scrollbar or native scrollbars (using css overflow) depending on the user's operating system
 *
 */
const ScrollArea = ({
  children,
  containerRef,
  disableNativeScrollbars,
  onScrollX,
  onScrollY,
  useNativeScrollbars,
  useNativeScollbarsInIE,
  className,
  style,
  ...otherProps
}) => {
  const [scrollX, setScrollX] = (0, _react.useState)(0);
  const [scrollY, setScrollY] = (0, _react.useState)(0);
  const nativeScrollAreaRef = (0, _react.useRef)();

  const renderNativeScollbars = () => {
    if (useNativeScrollbars) {
      return true;
    } else if (disableNativeScrollbars) {
      return false;
    } else if (_browser.default.isIOS() || _browser.default.isAndroid()) {
      return true;
    } else if (useNativeScollbarsInIE && _browser.default.isIE()) {
      return true;
    }

    return false;
  };

  const handlePSScrollX = (0, _throttle.default)(element => {
    if (typeof onScrollX === 'function') {
      onScrollX(element);
    }
  }, 200);
  const handlePSScrollY = (0, _throttle.default)(element => {
    if (typeof onScrollY === 'function') {
      onScrollY(element);
    }
  }, 200);
  const handleNativeScroll = (0, _throttle.default)(event => {
    const el = event.target;

    if (el) {
      if (typeof onScrollX === 'function' && el.scrollLeft !== scrollX) {
        onScrollX(el);
      }

      if (typeof onScrollY === 'function' && el.scrollTop !== scrollY) {
        onScrollY(el);
      }

      setScrollX(el.scrollLeft);
      setScrollY(el.scrollTop);
    }
  }, 200);

  if (renderNativeScollbars() && containerRef) {
    containerRef(nativeScrollAreaRef.current);
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: !renderNativeScollbars() ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: containerRef ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PerfectScrollbar, {
        role: "scrollbar",
        containerRef: containerRef,
        onScrollX: handlePSScrollX,
        onScrollY: handlePSScrollY,
        renderNativeScrollbars: renderNativeScollbars && !disableNativeScrollbars,
        ...otherProps,
        children: children
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PerfectScrollbar, {
        role: "scrollbar",
        onScrollX: handlePSScrollX,
        onScrollY: handlePSScrollY,
        renderNativeScrollbars: renderNativeScollbars && !disableNativeScrollbars,
        ...otherProps,
        children: children
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NativeScrollArea, {
      className: className ? `native-scrollbar-container ${className}` : `native-scrollbar-container`,
      style: style,
      ref: nativeScrollAreaRef,
      onScroll: handleNativeScroll,
      children: children
    })
  });
};

ScrollArea.defaultProps = {
  useNativeScrollbars: false,
  disableNativeScrollbars: false,
  useNativeScollbarsInIE: false
};
ScrollArea.propTypes = {
  onScrollX: _propTypes.default.func,
  onScrollY: _propTypes.default.func,
  useNativeScrollbars: _propTypes.default.bool,
  useNativeScollbarsInIE: _propTypes.default.bool,
  disableNativeScrollbars: _propTypes.default.bool,
  containerRef: _propTypes.default.oneOfType([_propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  }), _propTypes.default.func]),
  children: _propTypes.default.node
};
var _default = ScrollArea;
exports.default = _default;